import { useTranslation } from "../../../../hooks/useTranslation";
import { Nav } from "../../../ui/nav";
import styles from './index.module.scss';

import linkedinIcon from '../../../../assets/icons/linkedin.svg';
import { useLanguage } from "../../../../hooks/useLanguage";
import { useIsMobile } from "../../../../hooks/useIsMobile";

export const Explore = () => {
    const { t } = useTranslation();
    const { switchLanguageHref } = useLanguage();
    const isMobile = useIsMobile();

    const links = (
        <div className={styles.navigation}>
            <h3>{t('explore.title')}</h3>
            <div className={styles.links}>
                <Nav type="footer" onClick={() => {
                    const el = document.getElementById('home');
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth' });
                    }
                }}>{t('header.home')}</Nav>
                <Nav type="footer" onClick={() => {
                    const el = document.getElementById('solutions');
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth' });
                    }
                }}>{t('header.solutions')}</Nav>
                <Nav type="footer" onClick={() => {
                    const el = document.getElementById('experience');
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth' });
                    }
                }}>{t('header.experiences')}</Nav>
                <Nav type="footer" onClick={() => {
                    const el = document.getElementById('formation');
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth' });
                    }
                }}>{t('header.education')}</Nav>
                <Nav type="footer" onClick={() => {
                    const el = document.getElementById('portfolio');
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth' });
                    }
                }}>{t('header.portfolio')}</Nav>
            </div>
        </div>
    )
    
    return (
        <div className={styles.explore}>
            {!isMobile && links}
            <div className={styles.footer}>
                <Nav isLanguage href={switchLanguageHref}>{t('header.language')}</Nav>
                <button onClick={() => window.open('https://www.linkedin.com/in/timothée-dumas-702a151a1', '_blank')}>
                    <img src={linkedinIcon} alt="LinkedIn Icon" />
                </button>
            </div>
        </div>
    );
};